/* eslint-disable camelcase */
import { EstateNotifyKey } from '../estate/estate-settings.data';

export enum EmployeeRole {
  COMPANY_SUPERADMIN = 'company_superAdmin',
  COMPANY_PRESIDENT = 'company_president',
  DIRECTOR = 'director',
  MANAGER = 'manager',
  ADMIN = 'admin',
  ACCOUNTANT = 'accountant',
  CUSTOMER_SUPPORT = 'customer_supp',
  BOARD_MEMBER = 'board_member',
  FACILITY_MANAGER = 'facility_manager',
  SECURITY_WORKER = 'security_worker',
  CONCIERGE = 'concierge',
  OFFER_MANAGER = 'offer_manager'
}

// prettier-ignore
export interface AllPermissions {
  chat:           { view: true                                                                          };
  help:           { view: true                                                                          };
  c_dashboard:    { view: true;  edit: true                                                             };
  calendar:       { view: true;  edit: true;  anyEdit: true                                             };
  news:           { view: true;  edit: true                                                             };
  defects:        { view: true;  edit: true;  report: true;  settings: true                             };
  concierge:      { view: true;  edit: true;  report: true;  settings: true                             };
  resolutions:    { view: true;  edit: true;  report: true;  publish: true;  remind: true; votes: true; };
  polls:          { view: true;  edit: true;  report: true;  publish: true;  remind: true; votes: true; };
  booking:        { view: true;  edit: true;  report: true;  block: true                                };
  reckonings:     { view: true;               report: true;  import: true;   meters: true               };
  user:           { view: true;  edit: true;  report: true;  auth: true                                 };
  e_data:         { view: true;  edit: true                                                             };
  e_sub:          { view: true;  edit: true;  invite: true                                              };
  e_contact:      { view: true;  edit: true                                                             };
  e_review:       { view: true;  edit: true;  report: true;                                             };
  e_docs:         { view: true;  edit: true                                                             };
  e_util:         { view: true;  edit: true                                                             };
  e_renovations:  { view: true;  edit: true                                                             };
  e_settings:     { view: true;  edit: true                                                             };
  reports:        { view: true;               report: true                                              };
  websites:       { view: true;  edit: true                                                             };
  log:            { view: true;               report: true                                              };
  mailing:        { [key in EstateNotifyKey]: true                                                      };
  c_role:         { view: true;  edit: true;  report: true                                              };
  c_report:       { view: true;               report: true                                              };
  c_log:          { view: true;               report: true                                              };
  c_calendar:     { view: true;  edit: true                                                             };
  c_mailing:      { employee: true; ssoAccess: true;                                                    };
  c_sso:          { view: true;  edit: true                                                             };
  c_settings:     { view: true;  edit: true                                                             };
  bluebolt:       { view: true;  edit: true                                                             };
  offers:         { view: true;  edit: true                                                             };
}

export type EmployeePermissions = { [key in keyof AllPermissions]?: Partial<AllPermissions[key]> };

export interface DefaultRoles {
  all: AllPermissions;
  [role: EmployeeRole | string]: EmployeePermissions;
}
